import React, {useContext} from "react";
import {Box, ButtonRow, Title, Form, Section, Description} from "../styles";
import Button from "components/Button";
import AuthViewModel from "../viewModel";
import Input from "../component/Input";
import {FormProvider} from "react-hook-form";

function ResetPassword() {
  const {methods, onResetPassword} = useContext(AuthViewModel.Context);

  const {handleSubmit, getValues} = methods;

  return (
    <Box>
      <Title>Reset Password</Title>
      {getValues("sessionUserAttributes") && (
        <Description>Please reset your password on first sign-in</Description>
      )}
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onResetPassword)}>
          <Section $gap="20px">
            <Input type="password" label="Password" fieldName="Password" />
            <Input type="password" label="Confirm Password" fieldName="confirmPassword" />
            <ButtonRow>
              <Button type="submit">Save</Button>
            </ButtonRow>
          </Section>
        </Form>
      </FormProvider>
    </Box>
  )
}

export default AuthViewModel.withProvider(ResetPassword);
